module.exports = {"id":"dp2_3l3q4","text":"Engaging in Citizenship through Digital Technologies","instructions":"What best describes the platform economy?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_3l3q4-a1","text":"Economic activity mediated by digital platforms","score":3.7},{"id":"dp2_3l3q4-a2","text":"Traditional retail trade","score":1.3},{"id":"dp2_3l3q4-a3","text":"Government-only online services","score":1.3}],"category":"2.3"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.3/l3q4.json
// module id = 1035
// module chunks = 41